<template>
    <div class="quota-detail-container">
        <!-- 表头 -->
        <div class="quota-title">
            <div class="title-content">
                <div class="title-left">
                    <div class="title-pic">
                        <i class="el-icon-s-custom"/>
                    </div>
                    <div class="title-word">
                        <p>{{detailData.blCustName}}</p>
                        <p class="small-size">额度详情</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 额度信息 -->
        <quota-content :id="$route.params.id"/>
    </div>
</template>
<script>
import quotaContent from "./component/quotaContent.vue"
import {getQuotaList} from "@/api/factoring/factoringQuota"
import util from "@/mixins/util";
export default {
    name: 'FactoringQuotaDetail',
    mixins: [util],
    data() {
        return {
            id: '',
            detailData: ''
        }
    },
    components: {
        quotaContent
    },
    async mounted() {
        this.id = this.$route.params.id
        let res = await this.queryQuotaDetail(this.id)
        
        this.detailData = res
    },
    methods: {
        queryQuotaDetail(id) {
            return new Promise(async(resolve, reject) => {
                let res = await getQuotaList({blCustId: id,current:1,size: 100})
                let dataList = [
                    { code: "factoring_loop_credit", name: "isLoopCredit" },
                ];
                let dataSource = await this.dictionaryMap(dataList, res.data.data.records[0]);
                
                if(res.data.code == 200){
                    resolve(dataSource)
                }else {
                    this.$message({
                        type: 'warning',
                        message: res.data.msg
                    })
                }
            })
        }        
    }
}
</script>
<style lang="scss" scoped>
.quota-detail-container{
    .quota-title{
        padding: 10px 15px 0;
        .title-content{
            width: 100%;
            height: 80px;
            background-color: #fff;
            border-radius: 10px;
            box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;
            font-family: 微软雅黑, sans-serif;
            font-weight: 400;
            font-style: normal;
            .title-left{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                height: 100%;
                .title-pic{
                    width: 50px;
                    height: 50px;
                    border-radius: 25px;
                    margin-left: 20px;
                    text-align: center;
                    background-color: #FB6260;
                    margin-right: 15px;
                    i{
                        line-height: 50px;
                        font-size: 25px;
                        color: #fff;
                    }
                }
                .title-word{
                    p{
                        font-weight: 700;
                        font-style: normal;
                        font-size: 18px;
                        text-align: left;
                        line-height: 28px;
                        margin-bottom: 0;                       
                    }
                    .small-size{
                        font-weight: 400;
                        font-style: normal;
                        font-size: 12px;
                        color: #999999;
                        text-align: left;
                    }
                }
            }
        }
    }
}
</style>